import type {CssCustomProperties} from '@wix/component-protocol/schema'
import type {IVariableRepository} from './repository'
import type {IVariableDefaultsExtractor} from './defaults-extractor'
import type {IVariableStyleTransformer} from './style-transformer'

export interface IVariablesService {
    getStylesManifest(): CssCustomProperties
}

export class VariablesService implements IVariablesService {
    constructor(
        private readonly variableRepository: IVariableRepository,
        private readonly variableStyleTransformer: IVariableStyleTransformer,
        private readonly variableDefaultsExtractor: IVariableDefaultsExtractor
    ) {}

    getStylesManifest(): CssCustomProperties {
        const rawData = this.variableRepository.getRawVariablesData()

        if (!rawData?.variables || !Array.isArray(rawData.variables)) {
            return {}
        }

        const defaultValues = this.variableDefaultsExtractor.extractDefaults(rawData)

        return this.variableStyleTransformer.transformVariablesToStyles(rawData.variables, defaultValues)
    }
}
